export const setupSteps = ['Get Ready', 'Take Sample', 'All Done']
